/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Verify_SubtitleInputs */

const en_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your university email to verify your student status and unlock your plan.`)
};

const de_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib deine Universitäts-E-Mail-Adresse ein, um deinen Studentenstatus zu bestätigen und deinen Plan freizuschalten.`)
};

const fr_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre ton e-mail universitaire pour vérifier ton statut d'étudiant et débloquer ton plan.`)
};

const es_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese su correo universitario para verificar su estado de estudiante y desbloquear su plan.`)
};

const it_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la tua email universitaria per verificare il tuo status di studente e sbloccare il tuo piano.`)
};

const nl_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer je universiteits-e-mailadres in om je studentenstatus te verifiëren en je plan te ontgrendelen.`)
};

const pl_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wprowadź swój adres e-mail uniwersytecki, aby potwierdzić swój status studenta i odblokować swój plan.`)
};

const fi_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä yliopistosi sähköpostiosoite vahvistaaksesi opiskelijastatuksesi ja avataaksesi suunnitelmasi.`)
};

const da_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast din universitetsmail for at bekræfte din studerende status og låse din plan op.`)
};

const sv_onboarding_verify_subtitle = /** @type {(inputs: Onboarding_Verify_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange din universitetsmejl för att verifiera din studentstatus och låsa upp ditt plan.`)
};

/**
* | output |
* | --- |
* | "Enter your university email to verify your student status and unlock your plan." |
*
* @param {Onboarding_Verify_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_verify_subtitle = /** @type {((inputs?: Onboarding_Verify_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Verify_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_verify_subtitle(inputs)
	if (locale === "fr") return fr_onboarding_verify_subtitle(inputs)
	if (locale === "es") return es_onboarding_verify_subtitle(inputs)
	if (locale === "it") return it_onboarding_verify_subtitle(inputs)
	if (locale === "nl") return nl_onboarding_verify_subtitle(inputs)
	if (locale === "pl") return pl_onboarding_verify_subtitle(inputs)
	if (locale === "fi") return fi_onboarding_verify_subtitle(inputs)
	if (locale === "da") return da_onboarding_verify_subtitle(inputs)
	if (locale === "sv") return sv_onboarding_verify_subtitle(inputs)
	return en_onboarding_verify_subtitle(inputs)
});